import React, { useRef, useState } from "react";
import colorPalette from "@streeteasy/design-system/deprecated/colors";
import { ZillowMapLayer } from "@zillow/zillow-map-control";
import { array, arrayOf, func, number, obj, shape, string } from "prop-types";

import Polygon from "../Polygon";
import ZoomableMap from "../ZoomableMap";

const AreaSelectorMap = ({
  areas,
  hoveredAreaId,
  onClick,
  onHover,
  selectedAreaIds
}) => {
  const [mapReady, setMapReady] = useState(false);
  const zillowMapRef = useRef();

  const [center] = useState({
    northSouthLat: 40.7566,
    eastWestLng: -73.9694
  });

  const mapData = () =>
    areas
      .filter(area => area.decodedCoordinates?.length)
      .map(area => ({
        ...area,
        customPolygonArray: area.decodedCoordinates[0].map(coord => ({
          lat: coord[1],
          lng: coord[0]
        }))
      }));

  const handleOnPolygonHover = polygon => {
    onHover(polygon.id);

    if (window.areaSelectorTimeout) {
      global.clearTimeout(window.areaSelectorTimeout);
    }

    if (polygon.bounds) {
      window.areaSelectorTimeout = global.setTimeout(() => {
        if (!zillowMapRef.current) return;
        zillowMapRef.current.gmap.fitBounds(polygon.bounds);
      }, 1000);
    }
  };

  const renderPolygons = () =>
    mapData().map(area => {
      const isSelectedArea = selectedAreaIds.includes(area.id);
      const isHoveredArea = area.id === hoveredAreaId;
      return (
        <Polygon
          key={area.id}
          fillRegion={isSelectedArea || isHoveredArea}
          gmap={zillowMapRef.current.gmap}
          id={area.id}
          isSelected={isSelectedArea}
          onClick={() => onClick(area)}
          onHover={polygon => handleOnPolygonHover(polygon)}
          paths={area.customPolygonArray}
          shouldUpdateOnHover={isHoveredArea}
          strokeColor={colorPalette.koalaGrey}
          strokeWeight={1}
        />
      );
    });

  return (
    <>
      <ZoomableMap
        lat={center.northSouthLat}
        long={center.eastWestLng}
        mapCenter={center}
        mapId="area-selector"
        mapRef={zillowMapRef}
        onReady={() => setMapReady(true)}
        zoomLevel={11}
      >
        <ZillowMapLayer>{mapReady && renderPolygons()}</ZillowMapLayer>
      </ZoomableMap>
    </>
  );
};

AreaSelectorMap.propTypes = {
  areas: arrayOf(
    shape({
      branch_condition: string,
      children: array,
      decodedCoordinates: array,
      id: number,
      level: number,
      map_coordinates: obj,
      name: string,
      parent: obj
    })
  ).isRequired,
  hoveredAreaId: number,
  onClick: func.isRequired,
  onHover: func.isRequired,
  selectedAreaIds: arrayOf(number).isRequired
};

AreaSelectorMap.defaultProps = {
  hoveredAreaId: null
};

export default AreaSelectorMap;
